import { render, staticRenderFns } from "./[shipment-id].vue?vue&type=template&id=cbbe3b84&scoped=true"
import script from "./[shipment-id].vue?vue&type=script&lang=js"
export * from "./[shipment-id].vue?vue&type=script&lang=js"
import style0 from "./[shipment-id].vue?vue&type=style&index=0&id=cbbe3b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbe3b84",
  null
  
)

export default component.exports